import { deleteSubCategories, getCategories } from "_services";
import { ButtonHeading, CommonModal } from "components";
import BootstrapTable from "components/BootstrapTable";
import { AddSubCatergoryModal } from "modals";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaRegTrashCan } from "react-icons/fa6";
import { FiEdit } from "react-icons/fi";
import { Link, useLocation, useParams } from "react-router-dom";

const CategoriesDetail = () => {
  const { state } = useLocation();
  let { id } = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const [isDelete, setIsDelete] = useState();
  const [categoriesData, setCategoriesData] = useState(state);
  const [currentCategory, setCurrentCategory] = useState(state || null);
  const [subcategoryData, setSubcategoryData] = useState([]);

  useEffect(() => {
    if (id && categoriesData?.length > 0) {
      let newData = categoriesData?.find((el) => el?._id == id);
      setSubcategoryData(newData?.subCategories);
    }
  }, [id, categoriesData]);

  const fetchCategory = async (data) => {
    try {
      const res = await getCategories();

      if (res?.data?.categories) {
        setCategoriesData(res.data.categories);
      } else {
        toast.error(res?.responseMessage || "No categories found");
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  useEffect(() => {
    fetchCategory();
  }, []);

  const columns = [
    { header: "", accessor: "serial" },
    { header: "Title ", accessor: "title" },
    { header: "Subcategory Image", accessor: "subBategoryImage" },
    { header: "isSocial", accessor: "isSocial" },
    { header: "isGenre", accessor: "isGenre" },
  ];

  const handleDelete = (item) => {
    setIsDelete(item);
  };

  const submitDeleteCategory = async () => {
    const payload = {
      categoryId: state?._id,
      subcategorydId: isDelete?._id,
    };
    try {
      const res = await deleteSubCategories(payload);
      if (!!res) {
        setIsDelete(false);
        toast.success(res?.message);
        fetchCategory();
      } else {
        toast.error("Error !! ");
      }
    } catch (error) {
      throw error;
    }
  };

  const rowListData = (data) => {
    return data.map((item, i) => ({
      ...item,
      serial: (
        <React.Fragment>
          {state?.title !== "Contents" && (
            <div className="signDropdown">
              <button className="dropbtn11">
                <BsThreeDotsVertical />
              </button>
              <div className="dropdownContent">
                <div className="_avPointer" onClick={() => handleDelete(item)}>
                  <span className="_samAnchor">
                    <span className="deleteIcon_avt">
                      <FaRegTrashCan color="red" />
                    </span>
                    Delete
                  </span>
                </div>
              </div>
            </div>
          )}
        </React.Fragment>
      ),
      title: (
        <React.Fragment>
          <div className="" title={item?.title}>
            {item?.title || "-"}
          </div>
        </React.Fragment>
      ),
      subBategoryImage: (
        <React.Fragment>
          {item.imageUrl?.length > 0 ? (
            <div className="__imgMedia">
              <img
                src={item.imageUrl || "https://via.placeholder.com/400x300"}
                alt={`${item.imageUrl.length}`}
                width={40}
                height={30}
                className="_slidImg"
              />
            </div>
          ) : (
            <p>No Image Available</p>
          )}
        </React.Fragment>
      ),
      isSocial: (
        <React.Fragment>
          <div className="" title={item?.isSocial?.toString()}>
            {item?.isSocial === true
              ? "Yes"
              : item?.isSocial === false
              ? "No"
              : "-"}
          </div>
        </React.Fragment>
      ),
      isGenre: (
        <React.Fragment>
          <div className="" title={item?.isGenre?.toString()}>
            {item?.isGenre === true
              ? "Yes"
              : item?.isGenre === false
              ? "No"
              : "-"}
          </div>
        </React.Fragment>
      ),
    }));
  };

  const AddSubCategoryModal = {
    isOpen,
    closeModal: () => setIsOpen(false),
    modalMainClass: "_dashCommon_Modal _mdModal",
    modalTitle: "Add Subcategory",
    footerPart: true,
    submitTitle: "Add Subcategory",
    onSuccess: fetchCategory,
    categoryId: state?._id,
    categoryTitle: state?.title,
  };

  let propsDelete = {
    isOpen: isDelete,
    closeModal: () => setIsDelete(false),
    modalMainClass: "confirmModal_new",
    footerPart: true,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancelButtonTitle: "Close",
    onSubmit: submitDeleteCategory,
    // isLoadding: loading,
  };

  return (
    <>
      <ButtonHeading
        title={"Categories Detail"}
        onClick={() => setIsOpen(!isOpen)}
        buttonTitle={state?.title === "Contents" ? "" : "Add Subcategory"}
      />

      <div className="card-body pt-3">
        <div className="__userView pb-3">
          <h4>{currentCategory?.title}</h4>

          <img
            src={currentCategory?.imageUrl}
            alt={currentCategory?.title}
            style={{ width: "50px", height: "50px" }}
          />
          <div
            style={{ width: "100%", textAlign: "left", paddingLeft: "1.5em" }}
          >
            <h4>Subcategories</h4>
          </div>
        </div>
      </div>

      <div className="_tabWith_outTab __subCat_tab">
        <BootstrapTable
          columns={columns}
          data={rowListData(subcategoryData)}
          tablelMainClass="__categoriesTable"
        />
      </div>

      {isOpen && <AddSubCatergoryModal {...AddSubCategoryModal} />}

      <CommonModal {...propsDelete}>
        <p className="p-3">Are you sure you want to delete this SubCategory?</p>
      </CommonModal>
    </>
  );
};

export default CategoriesDetail;
